import React from 'react';
import type { HomeTopicCard } from '../homeTopicSections';
import { TopicServiceCard } from './TopicServiceCard';

interface TopicServiceCardGridProps {
  items: HomeTopicCard[];
  onSelect: (categoryId: string, slug: string) => void;
}

export const TopicServiceCardGrid: React.FC<TopicServiceCardGridProps> = ({ items, onSelect }) => (
  <div className="catalog-grid">
    {items.map((item, index) => (
      <div key={`${item.categoryId}-${item.slug}`} className="catalog-grid-item">
        <TopicServiceCard item={item} index={index} onSelect={onSelect} />
      </div>
    ))}
  </div>
);
